import { EventSnapshotList } from "./EventSnapshotList";

export default EventSnapshotList;
